import { en_us } from "../en_us";

export const en_us_hosp = {
  ...en_us
};
